module.exports = __webpack_public_path__ + "static/media/mindfull-logo.a858301a.jpg";